/**
 * Obtiene la lista de equipos activos.
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const GetTeams = async () => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + "sportplayer/teams", {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, message: errorData.message || 'Error al obtener los equipos.' };
        }
        
        const responseData = await response.json();
        return { success: true, data: responseData.data };
    } catch (error) {
        return { success: false, message: 'Error de conexión al obtener los equipos.' };
    }
};

/**
 * Obtiene los jugadores asociados a un ID de equipo específico.
 * @param {number|string} teamId 
 * @returns {Promise<{success: boolean, data?: any, message?: string}>}
 */
const GetPlayersByTeam = async (teamId) => {
    try {
        const response = await fetch(process.env.REACT_APP_API_URL + `sportplayer/teams/${teamId}/players`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, message: errorData.message || 'Error al obtener los jugadores del equipo.' };
        }
        
        const responseData = await response.json();
        return { success: true, data: responseData.data };
    } catch (error) {
        return { success: false, message: 'Error de conexión al obtener la plantilla de jugadores.' };
    }
};

export { GetTeams, GetPlayersByTeam };